import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-MyConsulationRequest',
  templateUrl: './MyConsulationRequest.component.html',
  styleUrls: ['./MyConsulationRequest.component.css']
})
export class MyConsulationRequestComponent implements OnInit {
   title = "My Consultation Request"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/MyConsulationRequest/MyConsulationRequest.component.ts